import Vue from 'vue'
import mutations from './mutations'
import sessionApi from '../../api/sessions'
import { loadItemsBuilder } from '../crudFactory'
import { objectToArray } from '../../utils/object'
const apiEndpoint = 'sessions'

export default {
  namespaced: true,

  state: {
    items: [],
    openedSessions: []
  },

  actions: {
    loadItems: loadItemsBuilder({ apiEndpoint }),
    async loadSessionsByDate ({ state, rootState, commit }, { dateFrom, dateTo, dateEndFrom, dateEndTo, type = 0 }) {
      const businessUnitId = rootState.businessUnits.currentBusinessUnit ? rootState.businessUnits.currentBusinessUnit.id : null
      var sessions = await sessionApi.getAllBetweenDates({ businessUnitId, dateFrom, dateTo, dateEndFrom, dateEndTo, type })
      let type1Tables = Object.values(rootState.tables.items).filter(x => x.type === 1).map(x => x.id)
      let filteredSessions = sessions.data.items.filter(x => !type1Tables.includes(x.table))
      commit('setSessions', filteredSessions)
      return filteredSessions
    },
    async loadType1SessionsByDate ({ state, rootState, commit }, { dateFrom, dateTo, dateEndFrom, dateEndTo, type = 0 }) {
      const businessUnitId = rootState.businessUnits.currentBusinessUnit ? rootState.businessUnits.currentBusinessUnit.id : null
      var sessions = await sessionApi.getAllBetweenDates({ businessUnitId, dateFrom, dateTo, dateEndFrom, dateEndTo, type })
      let type1Tables = Object.values(rootState.tables.items).filter(x => x.type === 1).map(x => x.id)
      let filteredSessions = sessions.data.items.filter(x => type1Tables.includes(x.table))
      commit('setSessions', filteredSessions)
      return filteredSessions
    },
    async loadOpenedSessions ({ state, rootState, commit }) {
      const businessUnitId = rootState.businessUnits.currentBusinessUnit ? rootState.businessUnits.currentBusinessUnit.id : null
      var sessions = await sessionApi.getOpenedSessions({ businessUnitId })
      let type1Tables = Object.values(rootState.tables.items).filter(x => x.type === 1).map(x => x.id)
      let filteredSessions = sessions.data.items.filter(x => !type1Tables.includes(x.table))
      commit('setOpenedSessions', filteredSessions)
      return filteredSessions
    },
    async loadOpenedType1Sessions ({ state, rootState, commit }) {
      const businessUnitId = rootState.businessUnits.currentBusinessUnit ? rootState.businessUnits.currentBusinessUnit.id : null
      var sessions = await sessionApi.getOpenedSessions({ businessUnitId })
      let type1Tables = Object.values(rootState.tables.items).filter(x => x.type === 1).map(x => x.id)
      let filteredSessions = sessions.data.items.filter(x => type1Tables.includes(x.table))
      commit('setOpenedSessions', filteredSessions)
      return filteredSessions
    },
    async endTableSession ({ state, rootState, dispatch }, { end_date, tableSessionId, electronic_device }) { // eslint-disable-line
      const deviceCms = await dispatch('devices/loadCentralDevice', {}, { root: true })
      const users = await dispatch('users/loadItems', {}, { root: true })
      // console.log(users)
      const electronicDeviceId = deviceCms.id
      const item = {
        end_date,
        reason: 2,
        issuer: users ? objectToArray(users).find(user => user.is_administrator).id : null
      }
      await sessionApi.endTableSession({ electronicDeviceId, tableSessionId, item })
      // return
    }
  },

  mutations: {
    ...mutations,
    setSessions (state, sessions) {
      Vue.set(state, 'items', sessions)
    },
    setOpenedSessions (state, sessions) {
      Vue.set(state, 'openedSessions', sessions)
    }
  }
}
